




import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { DepositBankAccountStatus } from '@/modules/deposit-bank-account/models/deposit-bank-account-resource.model'

@Component
export default class AdminDepositBankAccountStatusView extends Vue {
  @Prop({ required: true }) status: DepositBankAccountStatus
  @Prop() statusesInPersian: { [key in DepositBankAccountStatus]: string }
  @Prop() forceLabel: string

  get statusLabel() {
    return this.forceLabel
    || this.statusesInPersian ? this.statusesInPersian[this.status] : this.status
  }

  get colorClass() {
    return this.status === DepositBankAccountStatus.ACTIVE ? 'text-tes-green' : 'text-tes-red'
  }
}
